var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('HeaderV3', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "page wizard-mode-layout"
  }, [_vm.isSubmitting ? _c('div', {
    staticClass: "wizard-mode-layout__loading-overlay"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__loading-spinner"
  }), _c('div', {
    staticClass: "wizard-mode-layout__loading-text"
  }, [_vm._v("載入中...")])]) : _vm._e(), _c('router-view')], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }